import PriceList, { PriceListProps } from './PriceList';

export type { PriceListProps };
export default PriceList;
